module.exports = __webpack_public_path__ + "img/BOX.37d61889.svg";